<template>
  <div>
    <notifications></notifications>
    <div class="container-fluid">
      <div class="row pt-lg-0 pt-md-0 pt-sm-0 pt-2 mob-log">
        <div
          data-aos="fade-in"
          class="col-xl-7 col-lg-7 col-md-7 col-sm-6 d-flex justify-content-center align-items-center min-vh-lg-100 flex-column img-back-pages align-self-center order-lg-1 order-md-1 order-sm-1 order-2"
        >
          <div class="overimg-back"></div>

          <div class="container">
            <div class="col-xl-12 container-footer-left">
              <div class="content-description-login">
                <img
                  src="https://upcdn.io/FW25b8h/raw/logos/rhomtrip/logo-rhomtrip-mobility-vn.png"
                  alt="logo rhomtrip"
                  class="logo-sign no-movil"
                />

                <h2 class="title-login">
                  One platform for every operation.
                </h2>

                <p class="descrip-login">
                  The all-in-one platform for transport solutions.
                </p>

                <div class="features-login">
                  <div class="feature">
                    <i class="flaticon-calendar" aria-hidden="true"></i>
                    Real-time booking management
                  </div>
                  <div class="feature">
                    <i class="flaticon-wall-clock-1" aria-hidden="true"></i>
                    Availability & scheduling
                  </div>
                  <div class="feature">
                    <i class="flaticon-menu" aria-hidden="true"></i> Full
                    product catalog
                  </div>
                  <div class="feature">
                    <i class="flaticon-insurance-1" aria-hidden="true"></i>
                    Secure Payments
                  </div>
                </div>
              </div>

              <footer class="footer-pages-ext">
                <div class="bottom-footer-log">
                  <div class="partners-header login">
                    <a
                      href="https://www.iata.org"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><div
                        class="partnership-iata-code animate__animated animate__zoomIn"
                      >
                        <img
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/rhomtrip-iata-code.png"
                          alt="iata-code travel"
                          class="img-fluid-partner alinmov1"
                        />
                      </div>
                    </a>

                    <a
                      href="https://www.asta.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><div
                        class="partnership-asta animate__animated animate__zoomIn"
                      >
                        <img
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/asta-travel-advisors-w.png"
                          alt="asta"
                          class="img-fluid-partner alinmov1"
                        /></div></a
                    ><a
                      href="https://www.octo.travel/members"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="links-partnership animate__animated animate__zoomIn"
                      ><div class="partnership-octo">
                        <img
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/octo-travel.png"
                          alt="octo travel"
                          class="img-fluid-partner alinmov1"
                        />
                      </div>
                      <span>Founding Member</span></a
                    >

                    <a
                      href="https://www.tripadvisor.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><div
                        class="partnership-tripadvisor animate__animated animate__zoomIn"
                      >
                        <img
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/tripadvisor-2023-2024.png"
                          alt="tripadvisor"
                          class="img-fluid-partner alinmov1"
                        /></div
                    ></a>
                  </div>
                </div>

                <div class="content pt-2">
                  <div class="content-footer align-self-center p-0">
                    <ul class="social-media">
                      <li>
                        <a
                          href="https://www.linkedin.com/company/rhomtrip"
                          target="blank"
                        >
                          <i class="flaticon-bold flaticon-bold-linkedin"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.instagram.com/rhomtrip/"
                          target="blank"
                        >
                          <i class="flaticon-bold flaticon-bold-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.facebook.com/Rhomtrip"
                          target="blank"
                        >
                          <i
                            class="flaticon-bold flaticon-bold-facebook-app-symbol"
                          ></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.x.com/rhomtrip"
                          target="_blank"
                          aria-label="contact RhomTrip"
                        >
                          <i class="flaticon-web-twitter-1"></i>
                        </a>
                      </li>

                      <li>
                        <a href="mailto:info@rhomtrip.com" target="_blank">
                          <i class="flaticon-envelope"></i>
                        </a>
                      </li>

                      <li>
                        <a href="https://rhomtrip.com/contact" target="blank">
                          <i class="flaticon-bold-telephone"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="content pt-2">
                  <div class="align-self-center">
                    <p class="copyright">
                      Copyright © {{ systemInfo.year }}. RhomTrip OÜ™. Register
                      Nº: 14554819.
                    </p>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>

        <div
          class="col-xl-5 col-lg-5 col-md-5 col-sm-6 d-flex justify-content-center align-items-center min-vh-lg-100 align-self-center box-log order-lg-2 order-md-2 order-sm-2 order-1"
          data-aos="fade-in"
        >
          <div
            class="col-xl-8 col-lg-10 col-md-11 col-sm-12 col-12 pt-lg-0 pt-md-5 pt-sm-5 pt-0"
          >
            <div class="text-center mb-4 pages-all pt-0">
              <img
                src="https://upcdn.io/FW25b8h/raw/logos/rhomtrip/logo-rhomtrip-mobility.png"
                alt="logo rhomtrip"
                class="logo-mob"
              />
              <h1 class="title-view-2">Welcome back</h1>
              <div class="textInHorizontalLine">
                <span>Sign in</span>
              </div>
            </div>

            <div class="mb-0 mt-4">
              <form role="form" @submit.prevent>
                <div class="row">
                  <div class="col-12 mb-3 mt-2">
                    <base-input
                      id="email"
                      name="email"
                      placeholder="Email"
                      v-model="data.email"
                      indexTab="1"
                      label="Email"
                      markrequired
                      :error="
                        !$v.data.email.email || $v.data.email.$error
                          ? `Enter Email`
                          : ''
                      "
                      :focusact="true"
                    ></base-input>
                  </div>

                  <div class="col-12">
                    <base-input
                      v-model="$v.data.password.$model"
                      :label="$t('labelsForms.user.password')"
                      placeholder="Password"
                      name="password"
                      id="password"
                      :type="typePassword"
                      autocomplete="new-password"
                      maxlength="20"
                      indexTab="2"
                      class="input-append"
                      markrequired
                      :error="
                        !$v.data.password.minLength || $v.data.password.$error
                          ? `Enter a valid password`
                          : ''
                      "
                      v-bind:class="{
                        'is-invalid': $v.data.password.$error
                      }"
                      ><template slot="append">
                        <span @click="seePassword()" class="icon-button"
                          ><i
                            v-bind:class="{
                              'flaticon-view-1': typePassword == 'password',
                              'flaticon-hidden': typePassword == 'text'
                            }"
                          ></i
                        ></span>
                      </template>
                    </base-input>
                  </div>

                  <div class="col-12">
                    <base-checkbox
                      id="remember"
                      name="remember"
                      class="text-dark mb-3"
                      v-model="remember"
                      >Remember me</base-checkbox
                    >

                    <div class="text-center">
                      <base-button
                        type="primary"
                        class="min-button icon-move"
                        @click="login"
                        nativeType="submit"
                        >Sign in
                        <i class="ml-2 mr-0 flaticon-right-1 arrow-icon"></i
                      ></base-button>
                    </div>
                  </div>
                </div>
              </form>

              <div class="mt-2 text-center mb-sm-0 mb-3">
                <router-link to="/forgot-password" class="d-block f-14"
                  >Forgot your password?</router-link
                >
              </div>

              <div class="loading mt-5" v-if="load">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>

              <base-alert
                :type="alert.type"
                dismissible
                v-if="alert.status"
                class="alert-base"
              >
                <span class="alert-inner--icon">
                  <i :class="alert.icon" class="mr-2"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>{{ alert.title }}</strong>
                  {{ alert.message }}
                </span>
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </base-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbarpages from "@/layouts/Navbarpages";
import { AuthAPI } from "@/core/api";
import { mapMutations, mapGetters } from "vuex";
import layoutFooter from "@/layouts/ContentFooter";
import { required, minLength, email } from "vuelidate/lib/validators";
import {
  removeCredentials,
  ROLE_HIERARCHY,
  setCredentials
} from "@/helpers/commons.helpers";
export default {
  name: "SignIn",
  components: {
    navmenu: Navbarpages,
    layoutFooter: layoutFooter
  },
  data() {
    return {
      data: {
        email: "",
        password: ""
      },
      message: "",
      remember: false,
      load: false,
      alert: {
        type: "",
        title: "",
        message: "",
        icon: "",
        class: "",
        status: false
      },
      typePassword: "password",
      ROLE_HIERARCHY,
      src: "backRhomTrip2.jpg",
      photos: [
        { id: 1, title: "RhomTrip", name: "backRhomTrip1.jpg" },
        { id: 2, title: "RhomTrip", name: "backRhomTrip2.jpg" },
        { id: 3, title: "RhomTrip", name: "backRhomTrip3.jpg" },
        { id: 4, title: "RhomTrip", name: "backRhomTrip4.jpg" },
        { id: 5, title: "RhomTrip", name: "backRhomTrip5.jpg" }
      ]
    };
  },
  created() {
    removeCredentials();
    this.setSesion(null);
    this.setSigOut(false);
    if (localStorage.checkbox && localStorage.checkbox !== "") {
      this.remember = true;
      this.data.email = localStorage.user_email;
      this.data.password = localStorage.pass;
    } else {
      this.remember = false;
      this.data.email = "";
      this.data.password = "";
    }
    this.setTempPagination({
      currentPage: 1,
      query: "",
      queryTemp: "",
      filteredTabStatus: "all",
      limit: 10,
      status: false
    });
    this.src = this.photos[this.getRandomCover()].name;
  },
  methods: {
    /**
     * Sign in the user.
     * - Validate form inputs.
     * - Call the login API.
     * - On success, set session and navigate to reservations.
     * - On error, show an alert with the error message.
     */
    async login() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.load = true;
      try {
        this.rememberMe();
        let { data } = await AuthAPI.login(this.data);
        if (
          data &&
          data.status &&
          this.isRoleAllowed(data.data.role, ROLE_HIERARCHY)
        ) {
          let sesion = data.data;
          sesion["status"] = true;
          setCredentials(sesion);
          this.setSesion(sesion);
          this.setSettings(sesion.settings);
          const redirect = this.$route.query.redirect || "/reservations";
          this.$router.push(redirect);
        } else {
          this.setAlert(
            "danger",
            "Error!",
            "Incorrect Email or Password Entered",
            "alert-danger",
            "flaticon-remove"
          );
        }
      } catch (error) {
        this.mapApiErrorToMessage(error);
      } finally {
        this.load = false;
      }
    },
    /**
     * Check if the user's role is allowed access.
     * @param {string} userRole - The role of the user.
     * @param {Array} allowedRoles - The roles that are allowed access.
     * @returns {boolean} - True if the role is allowed, false otherwise.
     */
    isRoleAllowed(userRole, allowedRoles) {
      return allowedRoles.includes(userRole);
    },
    /**
     * Set the alert message and type.
     * @param {string} type - The type of the alert (e.g., success, danger).
     * @param {string} title - The title of the alert.
     * @param {string} message - The message of the alert.
     * @param {string} alertClass - The CSS class for the alert.
     * @param {string} icon - The icon class for the alert.
     */
    setAlert(type, title, message, alertClass, icon = "") {
      this.alert = {
        type: type || "info",
        title: title || "",
        message: message || "",
        icon: icon || "",
        class: alertClass || "",
        status: true
      };
    },
    /**
     * Map API error responses to user-friendly messages.
     * @param {Object} error - The error object from the API response.
     */
    mapApiErrorToMessage(error) {
      if (error.response.status === 404) {
        let data = error.response.data.data;
        if (data.profile === "inactive") {
          this.setAlert(
            "warning",
            "Important!",
            "This user is currently inactive",
            "alert-warning",
            "flaticon-warning-1"
          );
          return;
        }
      }
      this.setAlert(
        "danger",
        "Error!",
        "Incorrect Email or Password Entered",
        "alert-danger",
        "flaticon-remove"
      );
      return;
    },
    /**
     * Remember the user's email and password if the remember-me option is checked.
     * Persist this information in localStorage.
     */
    rememberMe() {
      if (this.remember && this.data.email !== "") {
        localStorage.user_email = this.data.email;
        localStorage.pass = this.data.password;
        localStorage.checkbox = this.remember;
      } else {
        localStorage.user_email = "";
        localStorage.checkbox = "";
        localStorage.pass = "";
      }
    },
    /**
     * Get a random cover image from the predefined list.
     * @returns {number} - A random index for the cover image.
     */
    getRandomCover() {
      return Math.floor(Math.random() * this.photos.length);
    },
    /**
     * Toggle the visibility of the password.
     * Switch between text and password input types.
     */
    seePassword() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
    },
    ...mapMutations([
      "setSesion",
      "setSigOut",
      "setLoad",
      "setTempPagination",
      "setSettings",
      "setSystemInfo"
    ])
  },
  computed: {
    ...mapGetters(["systemInfo"])
  },
  validations: {
    data: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  }
};
</script>
